import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
    // Re-scroll after images/layout settle
    const id = requestAnimationFrame(() => window.scrollTo({ top: 0 }));
    const t = setTimeout(() => window.scrollTo({ top: 0 }), 200);
    return () => {
      cancelAnimationFrame(id);
      clearTimeout(t);
    };
  }, [pathname]);
  return null;
}
